<template>
  <div class="form-group">
    <label v-if="label" :for="inputId">{{ label }}</label>

    <input
        :id="inputId"
        :type="type"
        :placeholder="placeholder"
        v-model="innerValue"
        class="form-control"
        :min="min"
        :max="max"
        :step="step"
        :disabled="disabled"
        :readonly="readonly"
        :autocomplete="autocomplete"
        @blur="touchField"
    />

    <span v-if="errorMessage" class="error">{{ errorMessage }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(defineProps<{
  label?: string
  type?: string
  id?: string
  placeholder?: string
  modelValue: string | number | null
  errorMessage?: string
  validation?: any
  min?: number | string
  max?: number | string
  step?: number | string
  disabled?: boolean
  readonly?: boolean
  autocomplete?: string
  /** v-model Modifiers Support (für v-model.number / .trim) */
  modelModifiers?: { number?: boolean; trim?: boolean }
}>(), {
  type: 'text',
  modelValue: null,
})

const emit = defineEmits<{
  (e:'update:modelValue', v: string | number | null): void
}>()

// stabile ID
const uid = `fi-${Math.random().toString(36).slice(2)}`
const inputId = computed(() => props.id ?? uid)

// 2-Way Bind, synchron mit externen Prop-Änderungen
const innerValue = computed({
  get() {
    return props.modelValue
  },
  set(val: any) {
    let out: string | number | null = val

    // .trim
    if (props.modelModifiers?.trim && typeof out === 'string') {
      out = out.trim()
    }

    // Zahl erzwingen, wenn type=number ODER .number Modifier aktiv
    if (props.type === 'number' || props.modelModifiers?.number) {
      if (out === '' || out === null || typeof out === 'undefined') {
        out = null
      } else {
        const num = typeof out === 'number' ? out : Number(out)
        out = Number.isFinite(num) ? num : null
      }
    }

    emit('update:modelValue', out)

    // Live-Validierung
    if (props.validation?.$validate) props.validation.$validate()
  }
})

function touchField() {
  // Fehler erst nach Blur anzeigen
  if (props.validation?.$touch) props.validation.$touch()
}
</script>

